import type React from "react";
import { toJSTDayjs } from "../../../event-detail/utils";

export interface EventReservationDurationProps {
	start?: string | null;
	end?: string | null;
	size?: boolean;
}

export const EventReservationDuration: React.FC<
	EventReservationDurationProps
> = ({ start, end, size = false }) => {
	const formatDate = (date: string | null | undefined) => {
		if (!date) return "ー年ー月ー日\nー:ー";
		const d = toJSTDayjs(date);
		return `${d.format("YYYY年M月D日")}\n${d.format("HH:mm")}`;
	};

	const baseStyles: React.CSSProperties = {
		minWidth: "104px",
		color: "white",
		fontSize: "12px",
		fontWeight: "bold",
		whiteSpace: "pre-wrap",
		textAlign: "center",
		borderRadius: "4px",
		padding: size ? "4px" : "8px",
	};

	return (
		<div style={{ display: "flex", justifyContent: "center" }}>
			<div
				style={{
					...baseStyles,
					marginRight: "8px",
					backgroundColor: "#8ac926",
				}}
			>
				{formatDate(start)}
			</div>
			<div
				style={{
					...baseStyles,
					backgroundColor: "#ff595e",
				}}
			>
				{formatDate(end)}
			</div>
		</div>
	);
};
